import { $Locale, $ABTest, $RenderConfig, $WebUser, $UserAgent, $I18nText } from '@lemon8/web-app-shared/atom';
import { $ArticleComments, $ArticleDetail, $ArticleRelatedPosts } from 'shared/atoms/article';
import {
  $SharerABTest,
  $SharingPageLevelTraffic,
  $RootTraffic,
  $SharerDetail,
  $FeatureFlags,
} from 'shared/atoms/common';
import { $UserDetail, $UserPost, $UserRelatedUser } from 'shared/atoms/user';
import { $POIInfo, $POIPosts } from 'shared/atoms/poi';
import { $HashtagInfo, $HashtagRecentPost, $HashtagPopularPost } from './hashtag';

export * from './common';
export * from './article';
export * from './user';
export * from './poi';
export * from './hashtag';

export const Atoms = {
  $Locale,
  $ABTest,
  $RenderConfig,
  $WebUser,
  $UserAgent,
  $I18nText,
  $RootTraffic,
  $SharerABTest,
  $FeatureFlags,
  $SharerDetail,
  $SharingPageLevelTraffic,
};

export const AtomFamilies = {
  $ArticleDetail,
  $ArticleComments,
  $ArticleRelatedPosts,

  $UserDetail,
  $UserPost,
  $UserRelatedUser,

  $POIInfo,
  $POIPosts,

  $HashtagInfo,
  $HashtagRecentPost,
  $HashtagPopularPost,
};
